import { render, staticRenderFns } from "./VQueryBuilder.vue?vue&type=template&id=2ff459f6"
import script from "./VQueryBuilder.vue?vue&type=script&lang=js"
export * from "./VQueryBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports